module.exports = __webpack_public_path__ + "static/media/payment-method-disabled-mobile.887d7fb5.png";